import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => (
  <footer id="contact" data-testid="site-footer" className="bg-petrol text-ivoire">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 lg:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-14">
        <div className="md:col-span-5">
          <Link
            to="/"
            data-testid="footer-logo"
            aria-label="EQUORIS — Accueil"
            className="inline-block bg-ivoire rounded-2xl px-6 py-4 transition-transform duration-300 hover:-translate-y-0.5"
          >
            <img
              src="/assets/logo-full.png"
              alt="EQUORIS — Bâtir aujourd'hui. Durablement demain."
              className="h-20 w-auto"
            />
          </Link>
          <p className="mt-4 font-display italic text-lg text-ivoire/70">
            Bâtir aujourd'hui. Durablement demain.
          </p>
          <p className="mt-6 text-sm text-ivoire/60 leading-relaxed max-w-sm">
            Négoce, achat et vente de matériaux et produits destinés à la construction
            et à la rénovation, pour les professionnels du bâtiment.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-sage mb-5">
            EQUORIS SAS
          </p>
          <address className="not-italic text-sm text-ivoire/75 leading-relaxed">
            2 rue de la Levée
            <br />
            49400 Saumur
          </address>
          <p className="mt-4 text-sm text-ivoire/60 leading-relaxed">
            SIREN : 101 316 719
            <br />
            SIRET : 101 316 719 00018
            <br />
            RCS Angers
          </p>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-sage mb-5">
            Liens
          </p>
          <ul className="space-y-3 text-sm">
            <li>
              <Link
                to="/mentions-legales"
                data-testid="footer-mentions-legales"
                className="text-ivoire/75 hover:text-ivoire transition-colors duration-200"
              >
                Mentions légales
              </Link>
            </li>
            <li>
              <Link
                to="/politique-confidentialite"
                data-testid="footer-politique-confidentialite"
                className="text-ivoire/75 hover:text-ivoire transition-colors duration-200"
              >
                Politique de confidentialité
              </Link>
            </li>
            <li>
              <a
                href="/plaquette-commerciale-equoris.pdf"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-plaquette-link"
                className="text-ivoire/75 hover:text-ivoire transition-colors duration-200 inline-flex items-center gap-1"
              >
                Plaquette commerciale
                <ArrowUpRight className="w-3.5 h-3.5" />
              </a>
            </li>
            <li>
              <Link
                to="/recrutement"
                data-testid="footer-nous-rejoindre"
                className="text-ivoire/75 hover:text-ivoire transition-colors duration-200"
              >
                Nous rejoindre
              </Link>
            </li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-sage mb-5">
            Contact
          </p>
          <a
            href="mailto:contact@equoris.fr"
            data-testid="footer-email-link"
            className="text-sm text-ivoire/75 hover:text-ivoire transition-colors duration-200"
          >
            contact@equoris.fr
          </a>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-ivoire/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="text-xs text-ivoire/45">
          © 2026 EQUORIS SAS — Tous droits réservés.
        </p>
        <p className="text-xs text-ivoire/45">
          Matériaux de construction &amp; rénovation pour les professionnels.
        </p>
      </div>
    </div>
  </footer>
);
